module.exports = __webpack_public_path__ + "img/ship-mode.edf23c43.svg";